import React from "react";
import FlightAutoComplete from "../../widgets/flightSearchWidget/theme4/FlightAutoComplete";
import DesktopCalender from "../../calendar/flightCalender/theme4/DesktopCalender"
import cf from "../../../lib/utils/common";
import PaxConfig from "../../widgets/flightSearchWidget/theme4/PaxConfig";

const ModifyAdvanceSearchOneWay = ( props ) => {
    console.log("props===>",props);
  return (
    <>
     <div className={props.styles1.flight_search_details_container}>
              <div className={props.styles1.flight_search_details_main}>
              <div className={props.styles1.flight_search_details_row}>
     <div
          className={
           props.styles1.flight_search_column +
            " " +
            props.styles1.flight_search_depart_multicity+
            " " +
            props.styles.wd_20
          }
        >
          <FlightAutoComplete
            label="From"
            // id="flight_search_from"
            value={props.state.departureValue}
            state={props.state}
            styles={props.styles1}
            onclickFlightAutoComplete={() =>
              props.onclickFlightAutoComplete("departure")
            }
            placholder="Where are you going?"
            onClickSourceAndDestination={(city, airPortCode,airPortName) =>
             props.onClickSetDepartureGoingToValue(
                city,
                airPortCode,
                airPortName,
                "departure"
              )
            }
            onChangeSourceAndDestination={(value) =>
              props.onChangeSetDepartureGoingToValue(
                value,
                "departure"
              )
            }
            isAutoCompleteExpand={(bool) =>
              props.setState({ expandDepartureBoolean: bool })
            }
            autoCompleteData={
              !cf.isValueEmpty(props.getDepartureSuggestionList)
                ? props.getDepartureSuggestionList
                : []
            }
            expandAutoCompleteBool={
              !cf.isValueEmpty(props.state.expandDepartureBoolean)
                ? props.state.expandDepartureBoolean
                : false
            }
            leftIcon={
              <svg xmlns="http://www.w3.org/2000/svg" width="26" height="17">
                  <path fill-rule="evenodd" fill="#01445F" d="M23.819 6.123 8.442 12.885a1.015 1.015 0 0 1-.331.07.93.93 0 0 1-.474-.152L.924 8.43c-.126-.475-.225-.595-.285-.736-.179-.415.013-.897 1.031-1.076l1.294-.819a.82.82 0 0 1 .682 0L8.414 8.96l4.689-2.67-6.46-3.581a.817.817 0 0 1-.376-.398c.583-.413.004-.897.417-1.08l2.253-.99a.79.79 0 0 1 .589-.029L19.64 3.401l2.327-1.282a2.296 2.296 0 0 1 1.807 0c1.75.676 1.754 3.292.045 4.004zm-.695-2.505a.67.67 0 0 0-.52 0L19.456 5.5c-.191.42.024-.393-.609-.04L9.305 1.857l-.389.443 6.456 3.053a.82.82 0 0 1 .221 1.294.996.996 0 0 1-.266.184L8.72 9.746a.866.866 0 0 1-.266.061c-.14.011-.281-.014.006-.074L3.278 7.441l.052.098 4.875 3.66 14.919-6.587a.54.54 0 0 0 .265-.266c.128.374.009-.601-.265-.728zM1.398 15.35h22.895a.818.818 0 0 1 0 1.637H1.398a.819.819 0 0 1 0-1.637z"/>
              </svg>
            }
            errorMessage={"Enter Origin City"}
            isError={props.state.isError.departure}
            listWrapper={props.departureListWrapper}
            onKeyDownArrow={(event) => {
              props.onKeyDownArrow(
                event,
                "flightDataArray",
                props.getDepartureSuggestionList,
                "departure"
              );
            }}
          />
        </div>
        <span
                    className={props.styles1.flight_swapOnewayAdv}
                    tabIndex="2"
                    onKeyDown={props.onSwapKeyDownHandler}
                    onClick={() => {
                      props.onClickSwap();
                    }}
                  >
                     <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" version="1.1" id="Layer_1" x="0px" y="0px" viewBox="0 0 33 33">
                        <g>
                          <path class="st0" d="M16.5,32.2c-8.7,0-15.7-7-15.7-15.7s7-15.7,15.7-15.7s15.7,7,15.7,15.7S25.1,32.2,16.5,32.2z M16.5,1.8   C8.4,1.8,1.8,8.4,1.8,16.5c0,8.1,6.6,14.7,14.7,14.7c8.1,0,14.7-6.6,14.7-14.7C31.2,8.4,24.6,1.8,16.5,1.8z"></path>
                        </g>
                        <polygon class="st1" points="25.6,22.3 25.6,22.3 25.6,22.3 "></polygon>
                        <g>
                          <path class="st0" d="M26.9,15.9c0.3-0.3,0.4-1.2,0-1.5l-5.5-5.5c-0.3-0.3-0.9-0.3-1.2,0C20.1,9,20,9.2,20,9.4   c0,0.2,0.1,0.4,0.2,0.6l4.2,4.2l-17.8,0c-0.5,0-0.8,0.4-0.8,0.8l0,0c0,0.5,0.4,0.8,0.8,0.8h17.6"></path>
                          <path class="st0" d="M6.1,17.1c-0.3,0.3-0.4,1.2,0,1.5l5.5,5.5c0.3,0.3,0.9,0.3,1.2,0c0.2-0.2,0.2-0.4,0.2-0.6   c0-0.2-0.1-0.4-0.2-0.6l-4.2-4.2l17.8,0c0.5,0,0.8-0.4,0.8-0.8l0,0c0-0.5-0.4-0.8-0.8-0.8H8.8"></path>
                        </g>
                      </svg>

                  </span>
        <div
          className={
           props.styles1.flight_search_column +
            " " +
            props.styles1.flight_search_depart_multicity+
            " " +
            props.styles.wd_20
          }
        >
          <FlightAutoComplete
              label="To"
              // id="flight_search_to"
              value={props.state.goingToValue}
            state={props.state}
            styles={props.styles1}
            onclickFlightAutoComplete={() =>
              props.onclickFlightAutoComplete("goingTo")
            }
            placholder="Where are you going?"
            onClickSourceAndDestination={(city, airPortCode,airPortName) =>
             props.onClickSetDepartureGoingToValue(
                city,
                airPortCode,
                airPortName,
                "goingTo"
              )
            }
            onChangeSourceAndDestination={(value) =>
              props.onChangeSetDepartureGoingToValue(
                value,
                "goingTo"
              )
            }
            isAutoCompleteExpand={(bool) =>
              props.setState({ expandGoingToBoolean: bool })
            }
            autoCompleteData={
              !cf.isValueEmpty(props.getGoingToSuggestionList)
                ? props.getGoingToSuggestionList
                : []
            }
            expandAutoCompleteBool={
              !cf.isValueEmpty(props.state.expandGoingToBoolean)
                ? props.state.expandGoingToBoolean
                : false
            }
            leftIcon={
              <svg xmlns="http://www.w3.org/2000/svg" width="26" height="19">
                  <path fill-rule="evenodd" fill="#01445F" d="M24.293 18.987H1.398a.819.819 0 0 1 0-1.637h22.895a.818.818 0 0 1 0 1.637zm-2.001-4.807L5.715 11.466a1.031 1.031 0 0 1-.316-.122c-.137-.098-.246-.231.441-.386L2.52 3.307c-.526-.141-.543-.197-.22-.447.5-.446.203-.745.649-.669l2.036.348a.823.823 0 0 1 .573.372l2.744 4.524 5.058.824-3.605-6.305a.819.819 0 0 1 .84-1.216l2.635.397c-.005.03.177.137.302.297l6.258 7.874 3.132.508c.619.107 1.958.463 1.515.985 1.099 1.521-.324 3.716-2.145 3.381zm1.458-2.479c-.776-.149-.933-.251-1.11-.283l-3.396-.553c.116-.032-.397-.137-.533-.298L12.45 2.692l-.14-.068 3.321 6.306c.039.068.068.79.086.219.105.439-.167 1.151-.607.986.29.021-.215.024-.323.009L7.66 8.986a.872.872 0 0 1-.257-.094.815.815 0 0 1-.302-.284L4.354 4.87l.596-.52 1.485 5.573 16.098 2.612a.553.553 0 0 0 .368-.078c.256-.161.335-.499.849-.756z"/>
              </svg>
            }
            errorMessage={
              props.state.goingToValue !== "" &&
                props.state.departureValue ===
                props.state.goingToValue
                ? "Origin and destination cannot be same"
                : "Enter Destination City"
            }
            isError={props.state.isError.goingTo}
                      listWrapper={props.returnListWrapper}
            onKeyDownArrow={(event) => {
              props.onKeyDownArrow(
                event,
                "flightDataArray",
                props.getGoingToSuggestionList,
                "goingTo"
              );
            }}
          />
        </div>
        <div
          className={
            props.styles1.flight_search_column +
            " " +
            props.styles1.flight_search_depart_going_date
          }
        >
          <DesktopCalender
            label="Departure"
            // id="flight_departure"
            styles={props.styles1}
            value={
              !cf.isValueEmpty(props.state.departureDate)
                ? props.state.departureDate
                : ""
            }
            isdepartureDateValue={true}
            departureDate={props.state.departureDate}
            onChangeDate={(value) => {
              props.onChangeDepartureGoingDateValue(
                value,
                "goindeparturegTo"
              );
            }}
            iconImage={
              <svg xmlns="http://www.w3.org/2000/svg" width="19" height="19">
                  <path fill-rule="evenodd" fill="#01445F" d="M11.971.693c0-.383.378-.693.846-.693.468 0 .847.31.847.693v3.039c0 .383-.379.694-.847.694-.468 0-.846-.311-.846-.694V.693zM9.697 15.226c-.05 0-.089-.056-.089-.469 0-.26.039-.47.089-.47h2.433c.5 0-.027.21-.027.47 0 .413.527.469.027.469H9.697zM2.324 9.84c-.049 0-.089-.21-.089-.469 0-.26.04-.47.089-.47h2.317c.05 0 .089.21.089.47 0 .259-.039.469-.089.469H2.324zm3.786 0c-.149 0-.189-.21-.189-.469 0-.26.04-.47.189-.47h2.217c.05 0 .09.21.09.47 0 .259-.04.469-.09.469H6.11zm3.587 0c-.05 0-.089-.21-.089-.469 0-.26.039-.47.089-.47h2.433c.5 0-.027.21-.027.47 0 .259.527.469.027.469H9.697zm3.688 0c-.05 0-.09-.21-.09-.469 0-.26.04-.47.09-.47h2.316c.05 0 .09.21.09.47 0 .259-.04.469-.09.469h-2.316zM2.324 12.533c-.049 0-.089-.209-.089.107 0-.836.04-1.046.089-1.046h2.317c.05 0 .089.21.089 1.046 0-.316-.039-.107-.089-.107H2.324zm3.786 0c-.149 0-.189-.209-.189.107 0-.836.04-1.046.189-1.046h2.217c.05 0 .09.21.09 1.046 0-.316-.04-.107-.09-.107H6.11zm3.587 0c-.05 0-.089-.209-.089.107 0-.836.039-1.046.089-1.046h2.433c.5 0-.027.21-.027 1.046 0-.316.527-.107.027-.107H9.697zm3.688 0c-.05 0-.09-.209-.09.107 0-.836.04-1.046.09-1.046h2.316c.05 0 .09.21.09 1.046 0-.316-.04-.107-.09-.107h-2.316zM2.324 15.226c-.049 0-.089-.056-.089-.469 0-.26.04-.47.089-.47h2.317c.05 0 .089.21.089.47 0 .413-.039.469-.089.469H2.324zm3.786 0c-.149 0-.189-.056-.189-.469 0-.26.04-.47.189-.47h2.217c.05 0 .09.21.09.47 0 .413-.04.469-.09.469H6.11zM4.343.693c0-.383.378-.693.846-.693.468 0 1.171.31 1.171.693v3.039c0 .383-.703.694-1.171.694-.468 0-.846-.311-.846-.694V.693zM.938 6.647H17.84V3.149c0 .161-.48-.225-.882-.304a.424.424 0 0 0-.303-.126h-1.546a.47.47 0 1 1 0-.939h1.547c.674 0 .719.154.967.402.248.248.627.59.627.967v13.507c0 .674-.379.719-.627.967s-.293.627-.967.627H1.368c-.377 0-.719-.379-.967-.627C.153 17.374 0 17.32 0 16.655V3.149c0-.377.153-.719.401-.967.248-.248.59-.402.967-.402H3.21c.071 0 .281.21.281.469 0 .26-.21.47-.281.47H1.368c-.117 0-.224.048.272.126-.653.078-.702.455-.702.304v3.498zm16.922.94H.938v9.068c0 .117.049.224.702.304-.498.401-.391.891-.272.891h15.288c.118 0 .225-.49.304-.891.42-.078.9-.185.9-.304V7.587zM7.397 2.719a.469.469 0 1 1 0-.939h3.152c.26 0 .641.21.641.469 0 .26-.381.47-.641.47H7.397z"/>
              </svg>
            }
            startDate={
              !cf.isValueEmpty(props.state.departureDate)
                ? props.state.departureDate
                : ""
            }
            endDate={
              !cf.isValueEmpty(props.state.returnDate)
                ? props.state.returnDate
                : ""
            }
            startDateLimit={
              !cf.isValueEmpty(props.state.dateLimit)
                ? props.state.dateLimit
                : ""
            }
            dateFormat={"DD-MMM-YYYY"}
            changeVisibility={(bool) =>
              props.onchangeVisibility(bool, "departure")
            }
            isVisible={props.state.expandDepartureDateBoolean}
            type={"double"}
            doubleSelection={false}
          />
        </div>
      
        <div
            className={
              props.styles1.flight_search_column +
              " " +
              props.styles1.flight_search_class
            }
          >
            <div
              className={`${props.styles1.flight_cabin_class_cont} ${props.styles1.trav_pd0}`}
              onClick={() => props.onClickOpenPassangerList()}
            >
              <label>Traveller</label>
              <div className={props.styles1.flight_travIcon}>
                <svg width="15px" height="15px" viewBox="0 0 200 200"><g><path fill="#30C8CA" d="M100,188.716c-48.918,0-88.716-39.798-88.716-88.716S51.082,11.284,100,11.284S188.716,51.082,188.716,100 S148.918,188.716,100,188.716z M45.883,162.507c14.516,12.586,33.442,20.209,54.117,20.209c20.675,0,39.602-7.624,54.118-20.209 c-1.134-27.888-38.089-30.935-54.118-30.935S47.016,134.62,45.883,162.507z M100,17.284c-45.61,0-82.716,37.106-82.716,82.716 c0,22.237,8.82,42.452,23.146,57.331c1.983-10.823,9.079-19.279,20.815-24.682c12.708-5.85,28.09-7.077,38.755-7.077 c10.666,0,26.048,1.228,38.756,7.077c11.736,5.402,18.832,13.858,20.814,24.682c14.326-14.88,23.146-35.094,23.146-57.331 C182.716,54.39,145.609,17.284,100,17.284z M100,103c-17.409,0-31.572-14.163-31.572-31.572c0-17.409,14.163-31.572,31.572-31.572 c17.409,0,31.572,14.163,31.572,31.572C131.572,88.837,117.409,103,100,103z M100,45.856c-14.1,0-25.572,11.472-25.572,25.572 C74.428,85.528,85.9,97,100,97c14.101,0,25.572-11.472,25.572-25.572C125.572,57.328,114.101,45.856,100,45.856z"></path></g></svg>
              </div>
              <div
                className={`${props.styles1.flight_cabin_class_nameAdvance} ${props.styles1.flight_travler}`}
              >
                {`${props.state.paxAdultValue+props.state.paxChildrenValue+props.state.paxInfantValue}`}&nbsp;Passenger
              </div>
              {/* <div
                className={
                  props.styles1.flight_cabin_class_arrow_pass
                }
              >
                <svg
                  version="1.1"
                  id="Layer_1"
                  x="0px"
                  y="0px"
                  width="20px"
                  height="20px"
                  viewBox="0 0 30 30"
                  enableBackground="new 0 0 30 30"
                >
                  <path id="Path_1101" data-name="Path 1101" d="M339.293,85.293l1.414,1.414L334,93.414l-6.707-6.707,1.414-1.414L334,90.586Z" transform="translate(-327.293 -85.293)" fill-rule="evenodd"/>
                </svg>
              </div> */}
            </div>
            {props.state.openPaxList === true ? (
              <div
                className={
                  props.styles1.flight_search_pax_select_main
                }
                ref={props.passengerDropdownWrapper}
              >
                <div
                  className={
                    props.styles1.flight_search_column +
                    " " +
                    props.styles1.flight_search_pax
                  }
                >
                  <div className={props.styles1.flight_search_pax_newleft}>
                  <label>Adult</label>
                  <span>(+12 Years)</span>
                  </div>
                  <PaxConfig
                    value={
                      !cf.isValueEmpty(props.state.paxAdultValue)
                        ? props.state.paxAdultValue
                        : 0
                    }
                    onChangePaxValue={(value, type) =>
                      props.onClickChangePaxNumber("adult", value, type)
                    }
                    maxLimit={9}
                    minLimit={1}
                    totalPax={
                      +props.state.paxChildrenValue +
                      +props.state.paxAdultValue
                    }
                    styles={props.styles1}
                  />
                  
                </div>

                <div
                  className={
                    props.styles1.flight_search_column +
                    " " +
                    props.styles1.flight_search_pax
                  }
                >
                  <div className={props.styles1.flight_search_pax_newleft}>
                  <label>Children</label>
                  <span>(2-11 Years)</span>
                  </div>
                  <PaxConfig
                    value={
                      !cf.isValueEmpty(props.state.paxChildrenValue)
                        ? props.state.paxChildrenValue
                        : 0
                    }
                    onChangePaxValue={(value, type) =>
                      props.onClickChangePaxNumber(
                        "children",
                        value,
                        type
                      )
                    }
                    maxLimit={9}
                    minLimit={0}
                    totalPax={
                      +props.state.paxChildrenValue +
                      +props.state.paxAdultValue
                    }
                    styles={props.styles1}
                  />
                </div>

                <div
                  className={
                    props.styles1.flight_search_column +
                    " " +
                    props.styles1.flight_search_pax
                  }
                >
                  <div className={props.styles1.flight_search_pax_newleft}>
                  <label>Infant</label>
                  <span>(Below 2 Years)</span>
                  </div>
                  <PaxConfig
                    value={
                      !cf.isValueEmpty(props.state.paxInfantValue)
                        ? props.state.paxInfantValue
                        : 0
                    }
                    onChangePaxValue={(value, type) =>
                      props.onClickChangePaxNumber("infant", value, type)
                    }
                    maxLimit={+props.state.paxAdultValue}
                    minLimit={0}
                    totalPax={props.state.paxInfantValue}
                    styles={props.styles1}
                  />
                </div>
              </div>
            ) : null}
        
          </div>

          <div
            className={
              props.styles1.flight_search_column +
              " " +
              props.styles1.flight_search_class
            }
            ref={props.economyPopUpWrapper}
          >
            <div
              className={props.styles1.flight_cabin_class_cont}
              onClick={() => props.onClickOpenCabinClassList()}
            >
              <label>Cabin</label>
              <div
                className={props.styles1.flight_cabin_class_icon4}
              >
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="18">
                  <path fill-rule="evenodd" fill="#005A95" d="M12.767 15.73h-1.771v.523a1.18 1.18 0 0 1-1.18 1.181H.962v-1.181h8.854v-.523H4.785c-.534 0-1.002-1.016-1.14-1.532L1.43 4.471c-.724-1.259.023-2.554 1.283-2.891a2.36 2.36 0 0 1 2.891 1.669l1.9 7.103h5.158a2.432 2.432 0 0 1 2.454 2.124c.008.077.011.154.011.231.002 1.413-.407 3.003-2.36 3.023zm0-4.198h-6.17L4.464 3.555c-.169-.63-.816-1.004-1.284-.835-.792.169-1.04.816-.997 1.446l2.602 9.727h7.982a1.18 1.18 0 0 0 1.18-1.181c0-.102-.528-1.18-1.18-1.18zm.59-3.541a.885.885 0 1 1 0-1.77.885.885 0 0 1 0 1.77zm-.59-7.082h1.18V5.4h-1.18V.909z"/>
              </svg>
              </div>
              <div
                className={props.styles1.flight_cabin_class_nameAdvance}
              >
                {!cf.isValueEmpty(props.state.SelectedAdvanceSearchOneWayClassValue)
                  ? props.state.SelectedAdvanceSearchOneWayClassValue.label
                  : ""}
              </div>
              <div
                className={props.styles1.flight_cabin_class_arrow4}
              >
              <svg xmlns="http://www.w3.org/2000/svg" width="14" height="8">
                  <path fill-rule="evenodd" fill="#01445F" d="M11.606.458c.704-.008 1.103.082 1.515.021a1.073 1.073 0 0 1-.021 1.517L7.746 7.198l-.747-.769.748.772a1.072 1.072 0 0 1-1.554-.061L.942 1.996A1.074 1.074 0 0 1 .921.479C1.334.54 2.12.45 2.437.458L7.2 4.931 11.606.458z"/>
              </svg>
              </div>
              {props.state.openCabinClassList === true ? (
                <div
         
                  className={props.styles1.flight_cabin_class_list}
                >
                  {props.cabinClass.map((element, index) => {
                    return (<>
                     <label
                        key={"cabinClass" + index}
                        className={
                          props.styles1.flight_cabin_class_ele + 
                          " " +
                          props.styles1.CabinLabel
                        }
                        onClick={() => {
                          props.onChangeClassValue(element)
                          props.setState({
                            openCabinClassListOne: false,
                          });
                        }}
                      >
                        <input type="radio" checked={ element.label ===  props.state.SelectedAdvanceSearchOneWayClassValue?.label ? true : false } />
                        <span className={props.styles1.classTitle}>{element.label}</span>
                      </label>
                     
                      </>
                    );
                  })}
                </div>
              ) : null}
            </div>
          </div>

          {/* Pax Select */}
     
      </div>
    </div>
    <div className={props.styles.main_adv_multicity}>
     
             <div className={props.styles.advanc_addition_tabs}>
           
              <div className={`${props.styles.adv_tabs_split} ${props.styles.wd_20}`}>
              <div className={props.styles.icon_box_adv}>
              <svg width="15px" height="15px" viewBox="0 0 200 200"><g><path fill="#30C8CA" d="M100,188.716c-48.918,0-88.716-39.798-88.716-88.716S51.082,11.284,100,11.284S188.716,51.082,188.716,100 S148.918,188.716,100,188.716z M45.883,162.507c14.516,12.586,33.442,20.209,54.117,20.209c20.675,0,39.602-7.624,54.118-20.209 c-1.134-27.888-38.089-30.935-54.118-30.935S47.016,134.62,45.883,162.507z M100,17.284c-45.61,0-82.716,37.106-82.716,82.716 c0,22.237,8.82,42.452,23.146,57.331c1.983-10.823,9.079-19.279,20.815-24.682c12.708-5.85,28.09-7.077,38.755-7.077 c10.666,0,26.048,1.228,38.756,7.077c11.736,5.402,18.832,13.858,20.814,24.682c14.326-14.88,23.146-35.094,23.146-57.331 C182.716,54.39,145.609,17.284,100,17.284z M100,103c-17.409,0-31.572-14.163-31.572-31.572c0-17.409,14.163-31.572,31.572-31.572 c17.409,0,31.572,14.163,31.572,31.572C131.572,88.837,117.409,103,100,103z M100,45.856c-14.1,0-25.572,11.472-25.572,25.572 C74.428,85.528,85.9,97,100,97c14.101,0,25.572-11.472,25.572-25.572C125.572,57.328,114.101,45.856,100,45.856z"></path></g></svg>
              </div>
            <div className={props.styles.departure_main_box}>
              <div className={props.styles.label_fname}>
                <label htmlFor="fname" className="lablename-htl">
                RBD / Class
                  </label>
              </div>
              <div  onClick={props.onRBDClick}  className={props.styles.icon_box_advSrpInp}>{props.multiSelectRBDClassDropdown}</div>
            </div>
            </div>
           
                     <div className={`${props.styles.adv_tabs_split} ${props.styles.wd_20}`}>
                     <div className={props.styles.icon_box_adv}>
                     <svg xmlns="http://www.w3.org/2000/svg" width="26" height="13">
                        <path fill-rule="evenodd" fill="#01445F" d="m.924 8.43 6.713 4.373a.93.93 0 0 0 .474.152 1.02 1.02 0 0 0 .331-.07l15.377-6.762c1.709-.712 1.705-3.328-.045-4.004a2.296 2.296 0 0 0-1.807 0L19.64 3.401 9.526.212a.79.79 0 0 0-.589.029l-2.253.99c-.413.183.166.667-.417 1.08a.822.822 0 0 0 .376.398l6.46 3.581-4.689 2.67-4.768-3.161a.82.82 0 0 0-.682 0l-1.294.819C.652 6.797.46 7.278.639 7.694c.06.14.159.261.285.736zm2.354-.989L8.45 9.733c-.277.06-.136.085.004.074a.866.866 0 0 0 .266-.061l6.607-2.915a1.02 1.02 0 0 0 .266-.184.82.82 0 0 0-.221-1.294L8.916 2.29l.389-.433 9.542 3.603c.633-.353.418.46.609.04l3.148-1.882a.67.67 0 0 1 .52 0c.274.127.393 1.102.265.728a.54.54 0 0 1-.265.266L8.205 11.199 3.33 7.539l-.052-.098z"/>
                    </svg>
              </div>
            <div className={props.styles.departure_main_box}>
              <div className={props.styles.label_fname}>
                <label htmlFor="fname" className="lablename-htl">
                  Airlines
                </label>
              </div>

              <div className={props.styles.icon_box_advSrpInp}>{props.multiSelectDropdown}</div>
            </div>
            </div>
            
            <div className={props.styles.adv_tabs_split}>
              <div className={props.styles.icon_box_adv}>
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="19">
                  <path fill-rule="evenodd" fill="#01445F" d="M7.668 18.778H1.577c-.42 0-.761-.341-.761-.608 0-.574.341-.915.761-.915h6.091c1.212 0 .761.341.761.915 0 .267.451.608-.761.608zm-1.523-3.047H1.577a.762.762 0 0 1 0-1.523h4.568a.76.76 0 1 1 0 1.523zm-1.523-3.047H1.577a.762.762 0 0 1 0-1.524h3.045c.808 0 .762.341.762.762s.046.762-.762.762zm6.091 6.06c-.42.019-.776-.307-.795-.584-.019-.564.307-.921.727-.939a7.618 7.618 0 0 0 6.888-8.281c-.383-4.19-4.088-7.276-8.275-6.47C5.6 2.382 2.703 5.283 2.37 8.943a.762.762 0 1 1-1.517-.137C1.309 3.778 5.751.71 10.776.527c4.709.427 9.124 4.378 9.104 9.11-.768 4.736-4.382 8.698-9.098 9.104a.814.814 0 0 1-.069.003zM9.952 5.66c-.421 0-.762-.253-.762.167v3.81c0 .202.081.683.223.538l2.284 2.286a.761.761 0 0 0 1.077-.019c.816-.295.816-.763 0-1.059l-2.061-2.062V5.827c0-.42-.341-.167-.761-.167z"/>
              </svg>
              </div>
            <div className={props.styles.departure_main_box}>
              <div className={props.styles.label_fname}>
                <label htmlFor="fname" className="lablename-htl">
                  Departure Time
                </label>
              </div>
              <div className={`${props.styles.icon_box_advSrpInp} ${props.styles.icon_pdlft}`}>
                      {props.multiSelectDepartureTimeDropdown}

              </div>
            </div>
            </div>
          
          
                     <div className={`${props.styles.adv_tabs_split} ${props.styles.wd_20}`}>
                     <div className={props.styles.icon_box_adv}>
                     <svg width="15px" height="15px" viewBox="0 0 200 200"><g><path fill="#30C8CA" d="M100,188.716c-48.918,0-88.716-39.798-88.716-88.716S51.082,11.284,100,11.284S188.716,51.082,188.716,100 S148.918,188.716,100,188.716z M45.883,162.507c14.516,12.586,33.442,20.209,54.117,20.209c20.675,0,39.602-7.624,54.118-20.209 c-1.134-27.888-38.089-30.935-54.118-30.935S47.016,134.62,45.883,162.507z M100,17.284c-45.61,0-82.716,37.106-82.716,82.716 c0,22.237,8.82,42.452,23.146,57.331c1.983-10.823,9.079-19.279,20.815-24.682c12.708-5.85,28.09-7.077,38.755-7.077 c10.666,0,26.048,1.228,38.756,7.077c11.736,5.402,18.832,13.858,20.814,24.682c14.326-14.88,23.146-35.094,23.146-57.331 C182.716,54.39,145.609,17.284,100,17.284z M100,103c-17.409,0-31.572-14.163-31.572-31.572c0-17.409,14.163-31.572,31.572-31.572 c17.409,0,31.572,14.163,31.572,31.572C131.572,88.837,117.409,103,100,103z M100,45.856c-14.1,0-25.572,11.472-25.572,25.572 C74.428,85.528,85.9,97,100,97c14.101,0,25.572-11.472,25.572-25.572C125.572,57.328,114.101,45.856,100,45.856z"></path></g></svg>
              </div>
            <div className={props.styles.departure_main_box}>
              <div className={props.styles.label_fname}>
                <label htmlFor="fname" className="lablename-htl">
                  Supplier
                </label>
              </div>
              <div className={`${props.styles.icon_box_advSrpInp}`}>{props.multiSelectSupplierDropdown}</div>
            </div>
            </div>
            <label className={`${props.styles.checkbox_label} ${props.styles.wd_15}`}>
                <span className={props.styles.bagCheckbox}>
                    <input type="checkbox" checked={true}/>
                    <span className={props.styles.bagBox}>
                        <span className={props.styles.bagCheck}></span>
                    </span>
                </span>
                <span className={props.styles.advTitle}>Flexi Baggage</span>
            </label>
       
            <div className={props.styles.flight_Adv_wrap}>
              <button
                className={props.styles.flight_AdvBtn}
                onClick={props.onClickSearchFlight}
              >Search</button>
      
              </div>
              
          
          </div>
    </div>
    </div>
    </>
  );
};
export default ModifyAdvanceSearchOneWay;
